import { create } from 'zustand';

export interface DeferConfirmData {
  label: string;
  window: string;
}

interface DeferConfirmState {
  data: DeferConfirmData | null;
  openDeferConfirm: (data: DeferConfirmData) => void;
  closeDeferConfirm: () => void;
}

// Drives the singleton DeferConfirmModal (mounted once at the pickups page
// level, alongside ChangeSlotModal/RolloverToast). Opened after a successful
// "Defer to next day" response from EITHER the RolloverToast or the in-row
// PickupSlotCell buttons — both funnel through this store so only one
// confirmation instance is ever mounted.
//
// NOTE: like useSlotSelectionStore/useChangeSlotStore, this store is
// intentionally NOT exported from the stores barrel — import it via the
// direct path '@/stores/useDeferConfirmStore'.
const useDeferConfirmStore = create<DeferConfirmState>((set) => ({
  data: null,
  openDeferConfirm: (data: DeferConfirmData) => set({ data }),
  closeDeferConfirm: () => set({ data: null }),
}));

export default useDeferConfirmStore;
